// extracted by mini-css-extract-plugin
module.exports = {"container":"missing_translation-module--container--2BYk5","text":"missing_translation-module--text--240Ex"};